import { DomainInitPayload, Account } from '@sxm-de/dev-kits/web-sdk/types';
import { MapClientSdkToWebSdk } from '@sxm-de/dev-kits/web-sdk/utils';
import { recordPrivacyOptionForIdentity } from '../helpers/record-privacy-option-for-identity';

export type GetAccountFn = () => Promise<Account>;

export function initGetAccountFn({
    dependencies,
}: DomainInitPayload): GetAccountFn {
    const { appEventSdk, clientSdk } = dependencies;
    return async () => {
        try {
            const mapClientSdkToWebSdk: MapClientSdkToWebSdk<
                Awaited<ReturnType<typeof clientSdk.user.account>>,
                Account
            > = (account) => {
                return {
                    ...account,
                    accountNumber: account.accountNumber || '',
                    privacyAgreements: account.privacyAgreements || [],
                    specialHandlingFlag: account.specialHandlingFlag || null,
                    userOptedOut: (account as any).userOptedOut,
                };
            };
            const account = mapClientSdkToWebSdk(
                await clientSdk.user.account(),
            );
            if (account.userOptedOut) {
                appEventSdk.trackEvent({
                    event: 'optout-update',
                    customerInfo: { optOut: true },
                });
            } else if (
                !!window['OnetrustActiveGroups'] &&
                !window['OnetrustActiveGroups'].split(',').includes('C0004')
            ) {
                await recordPrivacyOptionForIdentity(dependencies);
            }
            return account;
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
